import Vue from 'vue';

const url = `${process.env.VUE_APP_EMAILENDPOINT}`;

export default {
  sendEmail(data) {
    return Vue.axios.post(`https://europe-west1-vaulted-sol-230813.cloudfunctions.net/emailSender`, data);
  }
};
